import { Box, Chip, Grid, Link, Typography } from '@mui/material'

import Section from '../../../../components/section'
import SubscriptionIcon from '../../../../images/subscription.svg'
import { getFormattedDate, getFormattedDateTime } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'

import useStyles from './index.styles'

const Subscription = ({ aboutData }: { aboutData: IFolderAbout }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const { subscriptions } = aboutData
  const subscription = subscriptions[0]
  const {
    subscriptionStatus,
    subscriptionId,
    paidToDate,
    chargeIntervalFrequency,
    nextRenewalDate,
    subscriptionCreatedDate,
    // creditCardValid,
    // reasonPaymentMethodNotValid,
  } = subscription || {}

  if (subscription)
    return (
      <Section
        titleComponent={
          <Grid
            container={true}
            direction="row"
            sx={[
              {
                alignItems: 'flex-start',
              },
              classes.subscriptionTitleGrid,
            ]}
          >
            <div>
              <Grid container={true} size={12}>
                <img src={SubscriptionIcon} alt="" />
                <Box
                  sx={{
                    marginLeft: 2,
                  }}
                >
                  <Typography component="p" variant="overline" sx={classes.subscriptionSubtitle}>
                    Subscription
                  </Typography>
                  <Chip
                    size="small"
                    label={subscriptionStatus}
                    color="primary"
                    sx={{
                      color: subscriptionStatus === 'Active' ? 'success.main' : 'error.main',
                      backgroundColor: subscriptionStatus === 'Active' ? 'success.shades.4p' : 'error.shades.4p',
                    }}
                  />
                </Box>
              </Grid>
            </div>
            <div>
              <Typography component="p" variant="overline" sx={classes.subscriptionSubtitle}>
                Subscription Id
              </Typography>
              <Link
                href={`https://sensorsystemshsb-sp.admin.rechargeapps.com/merchant/subscriptions/${subscriptionId}/details`}
                target="_blank"
                underline="hover"
              >
                {subscriptionId}
              </Link>
            </div>
            <div>
              <Typography component="p" variant="overline" sx={classes.subscriptionSubtitle}>
                Paid To
              </Typography>
              <Typography>{paidToDate ? getFormattedDate(paidToDate, 'MM/dd/yyyy') : 'N/A'}</Typography>
            </div>
            <div>
              <Typography component="p" variant="overline" sx={classes.subscriptionSubtitle}>
                Payment/Commitment
              </Typography>
              <Typography>{chargeIntervalFrequency}</Typography>
            </div>
          </Grid>
        }
        component={
          <Grid
            container={true}
            sx={[
              {
                paddingX: 1.5,
                paddingY: 2,
              },
              classes.subscriptionDetailsGrid,
            ]}
          >
            <div>
              <Typography variant="overline" sx={sharedClasses.secondaryText}>
                Date of Next Renewal
              </Typography>
              <Typography>{nextRenewalDate ? getFormattedDate(nextRenewalDate, 'MM/dd/yyyy') : 'N/A'}</Typography>
              <Typography component="p" variant="overline" sx={[sharedClasses.secondaryText, { marginTop: 2 }]}>
                Subscription Created
              </Typography>
              <Typography>{subscriptionCreatedDate ? getFormattedDateTime(subscriptionCreatedDate) : 'N/A'}</Typography>
              {/* <Typography component="p" variant="overline" color="text.secondary" marginTop={2}>
                Subscription Address Id
              </Typography>
              <Typography>{subscription.subscriptionAddressId}</Typography> */}
            </div>
            {/* <div>
              <Typography variant="overline" color="text.secondary">
                Valid Credit Card On File
              </Typography>
              {creditCardValid ? (
                <Typography>Yes</Typography>
              ) : (
                <Grid container={true} alignItems="center" gap={2}>
                  <Typography>No</Typography>
                  {reasonPaymentMethodNotValid && (
                    <Tooltip title={reasonPaymentMethodNotValid} arrow={true}>
                      <ErrorOutlined color="error" />
                    </Tooltip>
                  )}
                </Grid>
              )}
            </div> */}
          </Grid>
        }
        showEdit={false}
      />
    )
  return null
}

export default Subscription
